var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.083 1a5.5 5.5 0 0 0-5.5 5.5v.917a5.5 5.5 0 0 0 11 0V6.5a5.5 5.5 0 0 0-5.5-5.5ZM8.417 6.5a3.667 3.667 0 0 1 7.333 0v.917a3.667 3.667 0 0 1-7.333 0V6.5ZM12.083 14.75c-2.484 0-4.942.512-6.718.996A4.575 4.575 0 0 0 2 20.166V23h20.167v-2.834a4.575 4.575 0 0 0-3.366-4.42c-1.775-.484-4.233-.996-6.718-.996Zm-6.235 2.765c1.696-.463 3.979-.932 6.235-.932 2.257 0 4.54.47 6.237.933a2.74 2.74 0 0 1 2.013 2.65v1h-16.5v-1c0-1.241.826-2.327 2.015-2.65Z",
    fill: "currentColor"
  })));
};
export { SvgUser as ReactComponent };
export default __webpack_public_path__ + "d1cff72fa95e3fb381df2ab8cfc70e54.svg";